import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { HttpService } from 'projects/cms/src/app/core/http/http.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseComponent } from '../../base/components/base-component';
import { FileVariationHelper } from '../../functions/file-variation.helper';
import { __ } from '../../functions/object.functions';
import { BaseEnvironment, ENVIRONMENT } from '../../injection-tokens/environment';
import { DatabaseFile, DatabaseFileReleaseStatus } from '../../models/classes/files/File';
import { FilesService } from '../../services/files.service';

@Component({
  selector: 'intello-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ImageComponent extends BaseComponent implements OnInit, OnDestroy {

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  isLoading: boolean = true;

  allowDynamicSetting = false;

  objectUrl: string;

  // -----------------------------------------------------------------------------------------------------
  // @ VIEW CHILD/CHILDREN VARIABLES
  // -----------------------------------------------------------------------------------------------------

  @ViewChild('image', { static: true }) image: ElementRef;


  // -----------------------------------------------------------------------------------------------------
  // @ OUTPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  @Output() isLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  loadingContainerClass: InputSignal<string> = input<string>('');

  customClass: InputSignal<string> = input<string>('image');

  loadingClass: InputSignal<string> = input<string>('');

  height: InputSignal<string> = input<string>('auto');

  defaultImage: InputSignal<string> = input<string>('');

  width: InputSignal<string> = input<string>('auto');

  minHeight: InputSignal<string> = input<string>('initial');

  src: InputSignal<string | DatabaseFile> = input<string | DatabaseFile>('assets/150x150.png');

  variationName: InputSignal<string> = input<string>('Original');

  computedSource = rxResource({
    params: () => ({
      src: this.src()
    }),
    stream: ({ params }) => this.loadImage(params.src)
  })

  type: InputSignal<string> = input<string>();

  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private cdr: ChangeDetectorRef,
    private httpService: HttpService,
    private filesService: FilesService,
    @Inject(ENVIRONMENT) private environment: BaseEnvironment
  ) {
    super();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ LIFE CYCLE HOOKS
  // -----------------------------------------------------------------------------------------------------

  ngOnInit() {
    //this.loadImage();
    this.allowDynamicSetting = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    const urlCreator = window.URL || window.webkitURL;
    urlCreator.revokeObjectURL(this.objectUrl);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ PRIVATE METHODS
  // -----------------------------------------------------------------------------------------------------

  private loadImage(source: string | DatabaseFile): Observable<string> {

    if (!__.IsNullOrUndefinedOrEmpty(source)) {
      if (typeof source !== 'string') {
        if (source.releaseStatus === DatabaseFileReleaseStatus.Private) {
          return this.filesService.getPreSignedUrl(source.id, this.variationName())
            .pipe(
              map((data: string) => {
                this.image.nativeElement.src = data;
                this.isLoading = false;
                this.isLoaded.emit(true);
                return data;
              })
            );
        }

        this.image.nativeElement.src = FileVariationHelper.getSrc(source as any);
        this.isLoading = false;
        this.isLoaded.emit(true);
        return of(FileVariationHelper.getSrc(source as any, this.variationName()));
      }

      this.image.nativeElement.src = source as any;
      this.isLoading = false;
      this.isLoaded.emit(true);
      return of(source as any);
    }

    this.image.nativeElement.src = 'assets/150x150.png';
    this.isLoading = false;
    this.isLoaded.emit(true);
    return of(('assets/150x150.png'));
  }

}
